import { Spacer } from '@nextui-org/react';
import React from 'react';
import useHelp from './hooks/useHelp';

const Help: React.FunctionComponent = (): JSX.Element => {
  const { theme } = useHelp();
  return (
    <div>
      {/* Description and Switch */}
      <div className="flex flex-row flex-wrap items-center justify-between gap-5">
        <div>
          <p className="p-2 text-foreground-700">
            E aí, pessoal da equipe! Sabia que dá para desbravar o mundo da
            impressão sem stress usando o Mozilla Firefox? É isso mesmo, galera!
            Quando se trata de imprimir sem aquele irritante diálogo, o Firefox
            é o nosso parceiro número um. Vamos te contar o porquê!
          </p>
          <Spacer y={4} />
          <p className="p-2 text-foreground-700">
            <span className="font-semibold">
              Por que escolher o Mozilla Firefox no Modo Desenvolvedor para
              imprimir?
            </span>
          </p>
          <Spacer y={4} />
          <ol>
            <li className="p-2 text-foreground-700">
              <span className="font-semibold">Zero Papo Chato:</span> Nada de
              diálogos inconvenientes! Com o Firefox podemos burlar a impressão,
              sem aqueles pop-ups chatos perguntando se a gente tem certeza. É
              imprimir e pronto!
            </li>
            <Spacer y={4} />
            <li className="p-2 text-foreground-700">
              <span className="font-semibold">
                Mais Facilidade, Menos Enrolação:
              </span>{' '}
              Em qualquer tipo de dúvida, peça ajuda ao time de informática, e
              caso do seu Firefox ja esteja imprimindo automáticamente, é só
              ignorar e seguir com o baile.
            </li>

            <Spacer y={8} />
            <li className="p-2 text-foreground-700">
              <span className="font-semibold">1 - Abra o Mozilla Firefox:</span>{' '}
              Na barra de endereços do Firefox, digite{' '}
              <span className="font-semibold">about:config</span> e pressione
              &quot;Enter&quot;. Uma mensagem de aviso pode aparecer, dizendo
              que você está entrando em uma área restrita. Clique em
              <span className="font-semibold">
                &quot;Aceitar o Risco e Continuar&quot;
              </span>
              .
            </li>
            <li className="p-2 text-foreground-700">
              <span className="font-semibold">
                2 - Pesquise por{' '}
                <span className="font-semibold">
                  &quot;print.tab_modal.enabled&quot;
                </span>
                :
              </span>{' '}
              Na barra de pesquisa na parte superior da página about:config,
              digite{' '}
              <span className="font-semibold">print.tab_modal.enabled.</span>
            </li>
            <li className="p-2 text-foreground-700">
              <span className="font-semibold">
                3 - Desative o diálogo de impressão:
              </span>{' '}
              Dê um duplo clique sobre o resultado da pesquisa
              <span className="font-semibold">
                print.tab_modal.enabled
              </span>{' '}
              para definir o valor como{' '}
              <span className="font-semibold">false</span>. Isso desativará o
              diálogo de impressão.
            </li>
            <li className="p-2 text-foreground-700">
              <span className="font-semibold">Controle Total:</span> Quem usa o
              Firefox no Modo Desenvolvedor tem o controle nas mãos. Dá para
              personalizar as configurações de impressão como quiser, sem
              aqueles bloqueios inconvenientes.
            </li>
          </ol>
          <Spacer y={8} />
          <p className="p-2 text-foreground-700">
            <span className="font-semibold">
              E por que o Chrome não curte essa parada?
            </span>
            O Chrome, nosso amigo de longa data, é mais cuidadoso quando o
            assunto é segurança. A galera do Chrome pensa duas vezes antes de
            liberar o modo desenvolvedor para imprimir sem firulas. Eles
            acreditam que isso pode abrir brechas para possíveis abusos e
            ataques.
          </p>
          <p className="p-2 text-foreground-700">
            Então, se você precisa de liberdade total na hora de imprimir, vai
            de Firefox. Mas, se a segurança é a sua prioridade, respeita o
            Chrome que ele tá de olho na gente!
          </p>
          <p className="p-2 text-foreground-700">
            Agora que você já sabe, aproveite o Modo Desenvolvedor no Firefox e
            deixe a impressão fluir. Lembre-se, pessoal: menos stress, mais
            produtividade!
          </p>
          {/* Tooltip */}
          {/* <Tooltip
              className={theme}
              content={
                <div className="text-foreground-700">
                  <p className="p-2">
                    Desmarque a opção de conferência automática para que o
                    sistema aguarde uma ação manual sobre a impressão da
                    etiqueta
                  </p>
                </div>
              }
            >
              <div>
                <IoMdInformationCircleOutline className="h-6 w-6 text-foreground-400" />
              </div>
            </Tooltip> */}
        </div>
      </div>

      <Spacer y={4} />

      <Spacer y={12} />
    </div>
  );
};

export default Help;
